import { connect } from 'react-redux';
import { exitDuperbrowse } from '../redux/actionCreators';
import { getDuperbrowseStreamParent, getCurrentItem } from '../redux/selectors';
var mapStateToProps = function (state) { return ({
    parent: getDuperbrowseStreamParent(state),
    currentItem: getCurrentItem(state),
}); };
var mapDispatchToProps = {
    exitDuperbrowse: exitDuperbrowse,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=BackToStreamButton.container.js.map